  export enum AnswerType {
    CheckBox = 2
  }
